<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemMember',
})
</script>
<template>
  <div>
    <a-card>
      <div class="system-member-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="关键字">
                <a-input v-model:value="state.tableData.param.keyWord" placeholder="请输入姓名或手机号" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="数据范围">
                <a-cascader
                  v-model:value="state.tableData.param.siteId"
                  :options="stateT.areaMicroTree"
                  :field-names="{ value: 'id', label: 'value', children: 'children' }"
                  placeholder="请选择数据范围(选择队站)"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="角色">
                <a-select v-model:value="state.tableData.param.roleIdList" mode="multiple" placeholder="请选择角色类型" allow-clear>
                  <a-select-option v-for="item in stateT.roleList" :key="item.code" :value="item.code">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary"><SearchOutlined />查询</ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary"><RedoOutlined />重置</ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="add" @click="onOpenAddUser('add')" type="primary"><PlusOutlined />新增人员</ant-button>
                <a-button class="ml10" @click="onOpenUpload"> <UploadOutlined />批量导入 </a-button>
                <a-button class="ml10" @click="onOpenMemberUpload"> <FileTextOutlined />导入记录 </a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading" :pagination="false" :row-key="(record) => record.userId || record.id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'roleName'">
            {{ record.roleName || '暂无角色' }}
          </template>
          <template v-else-if="column.key === 'freeze'">
            <a-tag :color="record.freeze == 1 ? 'success' : 'default'">
              {{ record.freeze == 1 ? '启用' : '禁用' }}
            </a-tag>
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="onOpenEditUser('detail', record)">查看</a-button>
              <a-button type="link" size="small" @click="onOpenEditUser('edit', record)">编辑</a-button>
              <a-button type="link" size="small" @click="onResetPwd(record.userId)">重置密码</a-button>
              <a-popconfirm :title="record.freeze == 1 ? '确定禁用该用户？' : '确定启用该用户？'" @confirm="changFreeze(record)">
                <a-button type="link" size="small">{{ record.freeze == 1 ? '禁用' : '启用' }}</a-button>
              </a-popconfirm>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination
        v-model:current="state.tableData.param.pageNum"
        v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total"
        :page-size-options="['10', '20']"
        show-size-changer
        :show-total="(total) => `共 ${total} 条`"
        :showQuickJumper="true"
        @change="onPageChange"
        @show-size-change="onShowSizeChange"
      />
    </a-card>
    <UserDialog ref="userDialogRef" :role-list="stateT.roleList" :area-micro-tree="stateT.areaMicroTree" @create-staff="createStaff" @update-staff="updateStaff" @reaset-pwd="onResetPwd" />
    <PasswordDialog ref="passwordDialogRef" @update="updatePassword" />
    <UploadDialog ref="uploadDialogRef" @upload-success="uploadSuccess" />
    <ResultDialog ref="resultDialogRef" />
  </div>
</template>

<script setup lang="ts" name="systemMember">
import { reactive, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { SearchOutlined, PlusOutlined, RedoOutlined, UploadOutlined, FileTextOutlined } from '@ant-design/icons-vue'
import { useMember } from '@/store/system/member'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
const memberStore = useMember()
import UserDialog from './dialogNew.vue'
import PasswordDialog from './dialogPassword.vue'
import UploadDialog from './dialogUpload.vue'
import ResultDialog from './dialogResult.vue'

const router = useRouter()
const userDialogRef = ref()
const passwordDialogRef = ref()
const uploadDialogRef = ref()
const resultDialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 100, customRender: ({ index }: { index: number }) => index + 1 },
  { title: '人员ID', dataIndex: 'userNumber', key: 'userNumber', ellipsis: true },
  { title: '登录账号', dataIndex: 'username', key: 'username', ellipsis: true },
  { title: '姓名', dataIndex: 'fullName', key: 'fullName', ellipsis: true },
  { title: '数据范围', dataIndex: 'dataArea', key: 'dataArea', ellipsis: true },
  { title: '角色', dataIndex: 'roleName', key: 'roleName', ellipsis: true },
  { title: '手机号', dataIndex: 'tel', key: 'tel', ellipsis: true },
  { title: '更新时间', dataIndex: 'modifyTime', key: 'modifyTime', ellipsis: true },
  { title: '用户状态', dataIndex: 'freeze', key: 'freeze', width: 100 },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      keyWord: '',
      siteId: [] as string[],
      roleIdList: [] as string[]
    }
  }
})

const stateT = reactive({
  roleList: [] as any[],
  areaMicroTree: [] as any[],
  microAreaTree: [] as any[]
})

const resetFun = () => {
  state.tableData.param.keyWord = ''
  state.tableData.param.siteId = []
  state.tableData.param.roleIdList = []
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const params: any = { ...state.tableData.param }
    if (Array.isArray(params.siteId) && params.siteId.length > 0) {
      params.siteId = params.siteId[params.siteId.length - 1]
    }
    const data: any = await fetchWithPaginationFallback(
      (param) => memberStore.getStaffList(param),
      params
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const onOpenAddUser = (type: string) => {
  userDialogRef.value.openDialog(type)
}

const getUserId = (row: any) => row.userId || row.id

const onOpenEditUser = async (type: string, row: any) => {
  const info: any = await memberStore.getStaffInfo(getUserId(row))
  userDialogRef.value.openDialog(type, info)
}

const createStaff = async (params: any) => {
  try {
    const res: any = await memberStore.addStaffList(params)
    if (res.code === 200 || !res.code) {
      message.success('创建成功')
      userDialogRef.value.closeDialog()
      getTableData()
    } else {
      userDialogRef.value.stopSubmitLoading()
    }
  } catch {
    userDialogRef.value.stopSubmitLoading()
  }
}

const updateStaff = async (params: any) => {
  try {
    const res: any = await memberStore.postStaffUpdate(params)
    if (res.code === 200 || !res.code) {
      message.success('更新成功')
      userDialogRef.value.closeDialog()
      getTableData()
    } else {
      userDialogRef.value.stopSubmitLoading()
    }
  } catch {
    userDialogRef.value.stopSubmitLoading()
  }
}

const onResetPwd = (id: any) => {
  passwordDialogRef.value.openDialog(id)
}

const updatePassword = async (param: any) => {
  const res: any = await memberStore.resetPwd(param)
  if (res.code === 200 || !res.code) {
    message.success('重置密码成功')
    passwordDialogRef.value.closeDialog()
  }
}

const changFreeze = async (row: any) => {
  const params = {
    userId: getUserId(row),
    freeze: row.freeze == '1' ? '0' : '1'
  }
  const res: any = await memberStore.postStaffFreeze(params)
  if (res.code === 200 || !res.code) {
    message.success('更新成功')
    getTableData()
  }
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const onOpenUpload = () => {
  uploadDialogRef.value.openDialog()
}

const uploadSuccess = (data: any) => {
  uploadDialogRef.value.closeDialog()
  getTableData()
  resultDialogRef.value.openDialog(data)
}

const onOpenMemberUpload = () => {
  router.push('/system/memberUpload')
}

const init = async () => {
  const roleData: any = await memberStore.getNameTag()
  stateT.roleList = Array.isArray(roleData) ? roleData : []
  //const areaList = await memberStore.getMicroAreaSiteTreeByArea({})
  //stateT.microAreaTree = areaList || []
  const list: any = await memberStore.getAreaMicroTree({})
  stateT.areaMicroTree = list?.[0]?.children || []
  getTableData()
}

onMounted(() => {
  init()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
